// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3BonX","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__2IyFR"};